export const PRODUCT_LINE_IDS_TO_RANK = Object.freeze({
  PHYS_CONS: 1,
  DIG_CONS: 2,
  Other: 3,
  '-1': 4, //Unmapped
});

export const PRODUCT_LINE_FIELDS = Object.freeze({
  PARENT: 'parent',
  GLS: 'gls',
  EXCLUDED: 'excluded',
  IGNORED: 'ignored',
});

export const PRODUCT_LINE_MAPPING = Object.freeze({
  EDITABLE_FIELDS: [PRODUCT_LINE_FIELDS.PARENT, PRODUCT_LINE_FIELDS.GLS, PRODUCT_LINE_FIELDS.EXCLUDED, PRODUCT_LINE_FIELDS.IGNORED],
});

export const PRODUCT_LINE_ROOT = 'ALL';

export const PRODUCT_LINE_LATEST_VERSION = '0';

export const PRODUCT_LINE_STATUS = Object.freeze({
  UNMAPPED: 'Unmapped',
  STAGED: 'Staged',
});



// WEBPACK FOOTER //
// ./src/constants/product_line.jsx